import { Button } from 'components/Button';
import { rm } from 'utils';
import styles from './styles.scss';

type ReturnViewProps = {
  title: string;
  message: string;
  returnUrl: string;
};

/**
 * Creates an element that displays provided information.
 * Contains button redirecting to Customer Page's Login page, when costumer page or base page for HelpCenter
 */
export const MessageView = ({ title, message, returnUrl }: ReturnViewProps): JSX.Element => {
  return (
    <div className={styles.base}>
      <div className={styles.container}>
        <div>
          <h1>{title}</h1>
          <p>{message}</p>
        </div>
        <Button appearance="whitePill" className={styles.button} href={returnUrl}>
          {rm('CustomerPage_Nav_To_Orderhistory')}
        </Button>
      </div>
    </div>
  );
};
